export default __webpack_public_path__ + "static/media/toggle.3e2cc8eb.webp";